import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import IconButton from '@material-ui/core/IconButton'

const styles = (theme: CentricTheme) => ({
  root: {
    width: theme.styles.components.button.width,
    height: theme.styles.components.button.height
  }
})

interface MyProps extends StyledProps {
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean
  /** Function to be called on Button Click */
  onClick: (e) => void
  /** React component of an icon */
  icon: React.ReactNode

}

export class SecondaryIconButtonComponent extends React.Component<MyProps> {
  static defaultProps = {
    disabled: false,
    onClick:  () => {}
    }

  render() {

    const {classes, icon, onClick, disabled, ...otherProps} = this.props

    return (
      <IconButton
        classes={{root: classes.root}}
        {...otherProps}
        color='default'
        disabled={disabled}
        onClick={onClick}>
        {icon}
      </IconButton>
    )
  }
}

@(withStyles as any)(styles)
export class SecondaryIconButton extends SecondaryIconButtonComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/SecondaryIconButton.tsx